import React from "react";
import CourseData from "./CourseData";

function Course() {
  const courseData = [
    {
      id: "PRG",
      name: "Programming",
      content: [
        {
          id: "PRGB01",
          level: "beginner",
          data: [
            {
              id: "PRGBD01",
              topics: "React Hooks Series",
              source: [
                {
                  id: "PRGHOOKS01",
                  class: 1,
                  name: "useState Hook",
                  src: "https://www.youtube.com/embed/Is8gyIe2WaM",
                },
                {
                  id: "PRGHOOKS02",
                  class: 2,
                  name: "useEffect Hook",
                  src: "https://www.youtube.com/embed/xmPDF9B4pCI",
                },

                {
                  id: "PRGHOOKS03",
                  class: 3,
                  name: "useContext Hook",
                  src: "https://www.youtube.com/embed/7alYatJIeD8",
                },
              ],
            },
          ],
        },
        {
          id: "PRGI02",
          level: "intermediate",
          data: [
            {
              id: "PRGID01",
              topics: "Top 5 Clone Projects in React.JS",
              source: [
                {
                  id: "PRGCLONE01",
                  class: 1,
                  name: "Quora Clone",
                  src: "https://www.youtube.com/embed/videoseries?list=PLjMANImCvBolnCykdQtBd1Lj-bdoH6XOa",
                  // src: "https://www.youtube.com/embed/SwIrvwNOJcg",
                },
                {
                  id: "PRGCLONE02",
                  class: 2,
                  name: "Netflix Clone",
                  src: "https://www.youtube.com/embed/ghQL8mgObZI",
                },

                {
                  id: "PRGCLONE03",
                  class: 3,
                  name: "Facebook Clone",
                  src: "https://www.youtube.com/embed/hQDlM7yTYzI",
                },
                {
                  id: "PRGCLONE04",
                  class: 4,
                  name: "GitHub Clone",
                  src: "https://www.youtube.com/embed/gei1O3QPLso",
                },
                {
                  id: "PRGCLONE05",
                  class: 5,
                  name: "Telegram Clone",
                  src: "https://www.youtube.com/embed/xqOC5GNl1iI",
                },
                {
                  id: "PRGCLONE06",
                  class: 6,
                  name: "Twitter Clone",
                  src: "https://www.youtube.com/embed/g-bY6hf6GCw",
                },
                {
                  id: "PRGCLONE07",
                  class: 7,
                  name: "Google Drive Clone [Playlist]",
                  src: "https://www.youtube.com/embed/2XlDvbuuDbQ",
                },
                {
                  id: "PRGCLONE08",
                  class: 8,
                  name: "Signal App Clone [Playlist]",
                  src: "https://www.youtube.com/embed/videoseries?list=PLjMANImCvBon2KyNgN7ycKIb6khjpKXL1",
                },
              ],
            },
          ],
        },
        {
          id: "PRGA03",
          level: "advanced",
          data: [
            {
              id: "PRGAD01",
              topics: "Full Stack Project in MERN",
              source: [
                {
                  id: "PRGFULL01",
                  class: 1,
                  name: "Gmail Clone [Playlist]",
                  src: "https://www.youtube.com/embed/videoseries?list=PLjMANImCvBonK3JCgFTCYRXCDKcwrrm9b",
                },
                {
                  id: "PRGFULL02",
                  class: 2,
                  name: "YouTube Shorts Clone [Playlist]",
                  src: "https://www.youtube.com/embed/videoseries?list=PLjMANImCvBomOTdSx9HURq-jkNCj4jzuy",
                },

                {
                  id: "PRGFULL03",
                  class: 3,
                  name: "Customized Email",
                  src: "https://www.youtube.com/embed/kQTCLap8tvo",
                },
                {
                  id: "PRGFULL04",
                  class: 4,
                  name: "Cricbuzz Clone [Playlist]",
                  src: "https://www.youtube.com/embed/videoseries?list=PLjMANImCvBoksFDVWsj4bhw3o0Igi75Su",
                },
                {
                  id: "PRGFULL05",
                  class: 5,
                  name: "Discord Clone [Playlist]",
                  src: "https://www.youtube.com/embed/haazYaSys0E",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "DM",
      name: "Digital Maketing",
      content: [
        {
          id: "DMB01",
          level: "beginner",
          data: [
            {
              id: "DMBD01",
              topics: "SEO",
              source: [
                {
                  id: "DMSEO01",
                  class: 1,
                  name: "Off Page SEO - Backlinks, PR, Forums, Blogs, Articles etc",
                  src: "",
                },
                {
                  id: "DMSEO02",
                  class: 2,
                  name: "On Page SEO - Title, Tags, Description",
                  src: "",
                },

                {
                  id: "DMSEO03",
                  class: 3,
                  name: "On Page SEO - Keyword Density, Sitemap etc",
                  src: "",
                },
                {
                  id: "DMSEO04",
                  class: 5,
                  name: "Technical SEO - Page, Speed, formats, Schemas etc",
                  src: "",
                },
                {
                  id: "DMSEO05",
                  class: 5,
                  name: "Tools SEO - Google Analytics, Search Console, UberSuggest and ...",
                  src: "",
                },
              ],
            },
          ],
        },
        {
          id: "DMB02",
          level: "intermediate",
          data: [
            {
              id: "DMD01",
              topics: "Ads",
              source: [
                {
                  id: "DMAD01",
                  class: 1,
                  name: "Kick start with Google Ads",
                  src: "",
                },
                {
                  id: "DMAD01",
                  class: 2,
                  name: "Facebook Ads, LinkedIN Ads, Twitter Ads etc",
                  src: "",
                },
              ],
            },
            {
              id: "DMD02",
              topics: "Social Media",
              source: [
                {
                  id: "DMSM01",
                  class: 1,
                  name: "Marketing Strategies for all social medias",
                  src: "",
                },
                {
                  id: "DMSM02",
                  class: 2,
                  name: "E-mail Marketing",
                  src: "",
                },
              ],
            },
          ],
        },
        {
          id: "DMB03",
          level: "advanced",
          data: [
            {
              id: "DMWEB01",
              topics: "Website Creation through WIX",
              source: [
                {
                  id: "DMWEBWIX01",
                  class: 1,
                  name: "Themes & Plugins",
                  src: "",
                },
                {
                  id: "DMWEBWIX02",
                  class: 2,
                  name: "Payment Integration on Website",
                  src: "",
                },
              ],
            },
            {
              id: "DMWEB02",
              topics: "Website Creation through WORDPRESS",
              source: [
                {
                  id: "DMWEBWIX01",
                  class: 1,
                  name: "Themes & Plugins",
                  src: "",
                },
                {
                  id: "DMWEBWIX02",
                  class: 2,
                  name: "Payment Integration on Website",
                  src: "",
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  return <CourseData courseData={courseData} />;
}

export default Course;
